import * as React from 'react';
import Button from '@roo/roo/Button';
import { useHistory } from 'react-router';
import Toast from '@roo/roo/Toast';
import utils from '@/utils/utils';
import { getMessage } from './api';
import useUnreadCount from '@/hooks/use-unread-count';

import './index.scss';

interface Params {
    id?: string;
}

const { useState, useEffect, useCallback } = React;

const MessageContent: React.FC = () => {
    const [content, setContent] = useState('');
    const { mutate: updateUnreadCount } = useUnreadCount();
    const history = useHistory();
    useEffect(() => {
        const params = utils.urlParse() as Params;
        const { id } = params;
        if (!id) {
            Toast.open({
                title: '参数错误,3s后返回上一页',
                position: 'center',
                status: 'fail',
                duration: 3000,
            });
            setTimeout(() => {
                history.goBack();
            }, 3000);
            return;
        }
        getMessage(id).then(res => {
            setContent(res.data.content);
            updateUnreadCount();
        });
    }, [history, updateUnreadCount]);
    const handleClick = useCallback(() => {
        history.goBack();
    }, [history]);
    return (
        <div className="page">
            <Button onClick={handleClick} type="text">
                返回
            </Button>
            <div
                className="message_content"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: content,
                }}
            />
        </div>
    );
};

export default MessageContent;
